<template>
  <q-header reveal class="bg-white" height-hint="98">
    <q-toolbar>
      <q-btn flat dense round @click="toggleLeftDrawer" aria-label="Menu" icon="menu" class="text-primary" />

      <q-toolbar-title class="text-primary">
        
      </q-toolbar-title>
      {{ username }}
    </q-toolbar>
  </q-header>

  <q-drawer v-model="leftDrawerOpen" show-if-above bordered side="left" class="bg-grey-1" :width="260"
    :breakpoint="500">
    <q-list>
      <q-item clickable :to="{ name: 'main' }">
        <q-item-section avatar>
          <q-icon name="home" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Главная</q-item-label>
        </q-item-section>
      </q-item>
      <q-item clickable :to="{ name: 'manager_org' }">
        <q-item-section avatar>
          <q-icon name="people" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Настрйоки платежей</q-item-label>
        </q-item-section>
      </q-item>
      <q-item clickable :to="{ name: 'payments' }">
        <q-item-section avatar>
          <q-icon name="wallet" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Платежи</q-item-label>
        </q-item-section>
      </q-item>
      <q-item clickable :to="{ name: 'organistations_list' }">
        <q-item-section avatar>
          <q-icon name="people" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Организации</q-item-label>
        </q-item-section>
      </q-item>
      <q-item clickable :to="{ name: 'plan_edit' }">
        <q-item-section avatar>
          <q-icon name="settings" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Модули</q-item-label>
        </q-item-section>
      </q-item>


      <!-- <q-item clickable :to="{ name: 'documents_list' }">
        <q-item-section avatar>
          <q-icon name="post_add" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Шаблоны документов</q-item-label>
        </q-item-section>
      </q-item> -->

      <!-- <q-item clickable :to="{ name: 'bills_list' }">
        <q-item-section avatar>
          <q-icon name="post_add" class="text-primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Счета бухучета</q-item-label>
        </q-item-section>
      </q-item> -->
    </q-list>
  </q-drawer>

  <q-page-container>
    <div>
      <router-view />
    </div>
  </q-page-container>
</template>

<script>
import {ref} from "vue";
const orgs = [
  {
    id: 0,
    name: "name",
    is_approved: false,
    is_active: true,
  }
];
export default {
  name: "dashboard",
  setup () {
    const leftDrawerOpen = ref(false)
    function toggleLeftDrawer () {
      leftDrawerOpen.value = !leftDrawerOpen.value
    }
    return {
      leftDrawerOpen,
      toggleLeftDrawer
    }
  },
  data() {
    this.emitter.on('setAuthenticated', () => {
      this.username = this.$store.credentials
    })
    return {
      organisations: ref(orgs),
      username: ref('')
    }
  }

}
</script>

<style scoped>

</style>